module.exports = __webpack_public_path__ + "img/525.fed17204.jpg";